import { Routes } from 'config/routes';
import { ITabsItem } from 'modules/common/components/CardTabs';
import NavigationCardTabs from 'modules/navigation/components/NavigationCardTabs';
import React from 'react';

import LocationsTable from '../LocationsTable';
import OfficesTable from '../OfficesTable';
import RegionsTable from '../RegionsTable';

export default function LocationCardTabs() {
  const locations: ITabsItem = {
    content: <LocationsTable />,
    title: 'Locations',
    key: Routes.Locations,
  };
  const regions: ITabsItem = {
    content: <RegionsTable />,
    title: 'Regions',
    key: Routes.Regions,
  };
  const offices: ITabsItem = {
    content: <OfficesTable />,
    title: 'Offices',
    key: Routes.Offices,
  };
  return (
    <div>
      <NavigationCardTabs items={[locations, regions, offices]} />
    </div>
  );
}
